import * as React from "react"
import { useCart } from "hooks/useCart"
import { CartItem, APICart, CartMoney } from "types/cart"
import axios, { AxiosResponse } from "axios"

function fetchCart(items: CartItem[]) {
	const formData = new FormData()
	items.forEach((item) => {
		formData.append("products[]", item.id.toString())
		formData.append("quantities[]", item.quantity.toString())
	})
	return axios
		.post("/getCart", formData)
		.then(({ data }: AxiosResponse<APICart[]>) => {
			return { data }
		})
}

function calculateTotal(data: APICart[]) {
	return data.reduce(
		(acc, { quantity, price }) => acc + price * parseInt(quantity, 10),
		0
	)
}

function calculateTotalWithoutDiscount(data: APICart[]) {
	return data.reduce(
		(acc, { quantity, old_price }) =>
			acc + old_price * parseInt(quantity, 10),
		0
	)
}

interface CartData {
	data: APICart[]
}

type CartState = CartData & CartMoney & { loading: boolean }

const defaultState: CartState = {
	data: [],
	total: 0,
	totalWithoutDiscount: 0,
	discount: 0,
	loading: true,
}
function useFetchCart() {
	const { cart } = useCart()

	const [state, setState] = React.useState<CartState>(defaultState)

	React.useEffect(() => {
		if (cart.length === 0) {
			setState(() => ({ ...defaultState, loading: false }))
			return
		}
		setState((prevState) => ({ ...prevState, loading: true }))
		fetchCart(cart).then(({ data }) => {
			const totalWithoutDiscount = calculateTotalWithoutDiscount(data)
			const total = calculateTotal(data)
			setState({
				data,
				total,
				totalWithoutDiscount,
				discount: totalWithoutDiscount - total,
				loading: false,
			})
		})
	}, [cart])

	return state
}

export default useFetchCart
